/**
 * Created by muratzengin on 27/03/16.
 */
import { Injectable } from '@angular/core';
import { Item } from '@slarys/ufe-models';
import {Observable} from 'rxjs';

import * as _ from 'lodash';
import { AppSettings } from '@slarys/ufe-config';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ItemService {
  private __items: Observable<Array<Item>>;
  private __item: Observable<Item>;
  get items() {
    return this.__items;
  }

  set items(value) {
    this.__items = value;
  }

  get item() {
    return this.__item;
  }

  set item(value) {
    this.__item = value;
  }

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private httpClient: HttpClient) {}

  public getItemsByLocalUser(page): Observable<any> {
    const url =
      AppSettings.API_ENDPOINT + '/items/my-items?page=' + page + '&pageSize=10';
    return this.httpClient.get(url);
  }

  public getItemsByUser(
    id,
    page?: number,
    lc?: string,
    sts?: string,
    s?: string,
    layout?: string

  ): Observable<any> {
    let url =
      AppSettings.API_ENDPOINT + '/items/user/' + id;

    url += '?page=' + page;

    if (!_.isNil(lc)) {
      url += '&lc=' + lc;
    }
    if (!_.isNil(sts)) {
      url += '&sts=' + sts;
    }
    if (!_.isNil(s)) {
      url += '&s=' + s;
    }
    if (!_.isNil(layout)) {
      url += '&layout=' + layout;
    }

    return this.httpClient.get(url);
  }

  public getMyItemsWithOffers(
      page?: number,
  ): Observable<any> {
    const url =
        AppSettings.API_ENDPOINT + '/items/my-items-with-offers?page=' + page;

    return this.httpClient.get(url);
  }

  public getOfferedItemsByUser(page): Observable<any> {
    const url =
      AppSettings.API_ENDPOINT + '/items/my-offered-items?page=' + page;

    return this.httpClient.get(url);
  }

  public getFollowedItemsByUser(page): Observable<any> {
    const url = AppSettings.API_ENDPOINT + '/items/favorites?page=' + page;

    return this.httpClient.get(url);
  }

  public getItemsByCategoryTags(
    tag: string,
    page?: number,
    lc?: string,
    sts?: string,
    s?: string,
    layout?: string
  ): Observable<any> {
    let url = AppSettings.API_ENDPOINT + '/items/';
    if (!_.isNil(tag)) {
      url += 'tagsbycategory/' + tag;
    }
    url += '?page=' + page;

    if (!_.isNil(lc)) {
      url += '&lc=' + lc;
    }
    if (!_.isNil(sts)) {
      url += '&sts=' + sts;
    }
    if (!_.isNil(s)) {
      url += '&s=' + s;
    }
    if (!_.isNil(layout)) {
      url += '&layout=' + layout;
    }

    return this.httpClient.get(url);
  }

  public getItemsByQuery(
    tag: string,
    page?: number,
    lc?: string,
    sts?: string,
    s?: string,
    layout?: string
  ): Observable<any> {

    let url = AppSettings.API_ENDPOINT + '/items/';

    if (!_.isNil(tag)) {
      url += 'category/' + tag;
    }

    url += '?page=' + page;

    if (!_.isNil(lc)) {
      url += '&lc=' + lc;
    }
    if (!_.isNil(sts)) {
      url += '&sts=' + sts;
    }
    if (!_.isNil(s)) {
      url += '&s=' + s;
    }
    if (!_.isNil(layout)) {
      url += '&layout=' + layout;
    }

    return this.httpClient.get(url);
  }
  // public getItems (page:number): Observable<any> {
  //     return this.http.get(AppSettings.API_ENDPOINT+'/teklifler?page=' + page + '&tag=&periodic=as')
  //         .pipe(map(res => res.json()));
  // }

  public getItem(id): Observable<any> {
    const url =
      AppSettings.API_ENDPOINT + '/items/item/' + id;

    return this.httpClient.get(url);
  }

  public getItemsRaw(): Observable<any> {
    const url =
        AppSettings.API_ENDPOINT + '/items/raw';

    return this.httpClient.get(url);
  }

  public searchItem(query: string) {
    return this.httpClient.get(AppSettings.API_ENDPOINT + '/search?s=' + query);
  }

  // public saveItem(item: Item) {
  //     const headers = new HttpHeaders();
  //     headers.append('Content-Type', 'application/json');
  //     const response: any =
  //         this.httpClient.post(AppSettings.API_ENDPOINT + '/ilan/yeni',
  //             JSON.stringify(item),
  //             {headers: headers});
  //     return response;
  // }

  /** POST: add a new hero to the database */
  public saveItem(item: Item): Observable<Item> {
    return this.httpClient
      .post<Item>(
        AppSettings.API_ENDPOINT + '/items/create',
        item,
        this.httpOptions
      )
      .pipe
      // catchError
      ();
  }

  public saveItemAsTemporary(item: Item): Observable<Item> {
    return this.httpClient
        .post<Item>(
            AppSettings.API_ENDPOINT + '/items/create-temp',
            item,
            this.httpOptions
        )
        .pipe
        // catchError
        ();
  }

  public saveTemporaryAsItem(id): Observable<Item> {
    return this.httpClient
        .post<any>(
            AppSettings.API_ENDPOINT + '/items/save-temp',
            id,
            this.httpOptions
        )
        .pipe
        // catchError
        ();
  }

  public followItem(item: Item) {
    return this.httpClient
      .post<Item>(
        AppSettings.API_ENDPOINT + '/items/item/follow',
        item,
        this.httpOptions
      )
      .pipe
      // catchError
      ();
  }

  public unfollowItem(item: Item) {
    return this.httpClient
      .post<Item>(
        AppSettings.API_ENDPOINT + '/items/item/unfollow',
        item,
        this.httpOptions
      )
      .pipe
      // catchError
      ();
  }

  handleError(error: Response) {
    console.log(error);
    return Observable.throw(error.json() || 'Server error');
  }

  public submitOffer(item: Item): Observable<any> {
    return this.httpClient
      .post<Item>(
        AppSettings.API_ENDPOINT + '/items/item/submit-offer',
        item,
        this.httpOptions
      ).pipe();
  }

  public updateItem(item: Item) {
    return this.httpClient
      .post<Item>(
        AppSettings.API_ENDPOINT + '/items/item/update',
        item,
        this.httpOptions
      )
      .pipe
      // catchError
      ();
  }

  public cancelItem(item: Item) {
    return this.httpClient
      .post<Item>(
        AppSettings.API_ENDPOINT + '/items/item/cancel',
        item,
        this.httpOptions
      )
      .pipe
      // catchError
      ();
  }

  public completeItem(item: Item) {
    return this.httpClient
      .post<Item>(
        AppSettings.API_ENDPOINT + '/items/item/complete',
        item,
        this.httpOptions
      )
      .pipe
      // catchError
      ();
  }

  public acceptOffer(item: Item) {
    return this.httpClient
      .post<Item>(
        AppSettings.API_ENDPOINT + '/items/item/accept-offer',
        item,
        this.httpOptions
      )
      .pipe
      // catchError
      ();
  }

  public deleteOffer(item: Item) {
    return this.httpClient
      .post<Item>(
        AppSettings.API_ENDPOINT + '/items/item/delete-offer',
        item,
        this.httpOptions
      )
      .pipe
      // catchError
      ();
  }

  public deleteFile(id) {
    const response: any = this.httpClient.delete(
      AppSettings.API_ENDPOINT + '/items/files/delete/' + id
    );
    return response;
  }

  public editOffer(item: Item) {
    return this.httpClient
      .post<Item>(
        AppSettings.API_ENDPOINT + '/items/item/update-offer',
        item,
        this.httpOptions
      )
      .pipe
      // catchError
      ();
  }
}
